export interface ConfigInterface {
  suffix?: string;
  enable?: boolean;
}

export const defaultConfig: ConfigInterface = {
  suffix: 'testid',
  enable: true,
};
